const environment = process.env.ENVIRONMENT;

export default class ConfigProvider {
  static get CONFIG(): { [key: string]: string | undefined } {
    return {
      environment,
      serviceName: 'admin',
      authUrl: `VUE_APP_AUTH_URL`,
      authClientId: `VUE_APP_AUTH_CLIENT_ID`,
      authRedirectUrl: `VUE_APP_AUTH_REDIRECT_URI`,
      authAmrHint: `VUE_APP_AUTH_AMR_HINT`,
      baseApiUrl: `VUE_APP_BASE_API_URL`,
      endpointsUrl: `VUE_APP_BASE_API_URL`,
      epubGuideGeneratorUrl: `VUE_APP_EPUB_GUIDE_GENERATOR_API_URL`,
      thePublisherUrl: `VUE_APP_THE_PUBLISHER_API_URL`,
      theArticlePublisherUrl: `VUE_APP_THE_ARTICLE_PUBLISHER_API_URL`,
      studioJobsUrl: `VUE_APP_STUDIO_JOBS_API_URL`,
      booksContentRegistryUrl: `VUE_APP_BOOKS_API_URL`,
      basePath: process.env.BASE_URL || '/',
    };
  }

  static value(name: string): string {
    if (!(name in this.CONFIG)) {
      // eslint-disable-next-line no-console
      console.debug(`Configuration: There is no key named "${name}"`);
      return '';
    }

    const value = this.CONFIG[name];

    if (typeof value === 'undefined') {
      // eslint-disable-next-line no-console
      console.debug(`Configuration: Value for "${name}" is not defined `);
      return '';
    }

    if (typeof value === 'string' && value.startsWith('VUE_APP_')) {
      const envValue = process.env[value];
      if (envValue) {
        // eslint-disable-next-line consistent-return
        return envValue;
      }

      // eslint-disable-next-line no-console
      console.debug(`Configuration: Environment variable "${value}" is not defined`);
    }

    // eslint-disable-next-line consistent-return
    return value;
  }
}

type IncludeParam = { [key: string]: string };

const hack = (path: string, inc: IncludeParam = {}) => {
  if (path === 'content' && !inc.contentType) {
    // eslint-disable-next-line
    inc.contentType = 'Book';
  }
};

export const getEndpointUrl = (path: string, operation = '', inc: IncludeParam = {}): string => {
  const cleanInc = JSON.parse(JSON.stringify(inc));
  let localPath =
    process.env[`VUE_APP_${path.toUpperCase()}_API_URL_${operation.toUpperCase()}`] ??
    process.env[`VUE_APP_${path.toUpperCase()}_API_URL`];
  hack(path, cleanInc);
  Object.getOwnPropertyNames(cleanInc).forEach((propName) => {
    localPath = localPath?.replace(propName.toUpperCase(), cleanInc[propName]);
  });
  return localPath ?? `${ConfigProvider.value('endpointsUrl')}${path}`;
};

export const getOptionalIdField = (path: string): string | undefined =>
  process.env[`VUE_APP_${path.toUpperCase()}_API_ID`];

export const shouldUnwrapData = (path: string): boolean =>
  !((process.env[`VUE_APP_${path.toUpperCase()}_API_UNWRAP_DATA`] ?? 'true') === 'false');
